import { type App } from 'vue';
import VueVirtualScroller from 'vue3-virtual-scroller';
import 'vue3-virtual-scroller/dist/vue3-virtual-scroller.css';

export function virtualScrollerPlugin(app: App) {
  // eslint-disable-next-line
  app.use(VueVirtualScroller as any);
}
